<template>
  <div class="md-layout text-center">
    <div class="md-layout-item md-size-50 md-small-size-100">
      <lock-card>
        <img slot="imageProfile" :src="image" class="img" />
        <h4 slot="title" class="title">Portal Member</h4>
        <md-field slot="content">
          <label>Enter Password</label>
          <md-input v-model="password" type="password" />
        </md-field>
        <md-button slot="footer" href class="md-success md-round">Unlock</md-button>
      </lock-card>
    </div>
  </div>
</template>
<script>
import { LockCard } from "@/components"
export default {
  components: {
    LockCard
  },
  data() {
    return {
      password: null,
      image: "./img/default-avatar.png" // "./img/faces/avatar.jpg"
    }
  }
}
</script>
<style></style>
